"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSurveyToJSON = exports.AdSurveyFromJSONTyped = exports.AdSurveyFromJSON = exports.instanceOfAdSurvey = void 0;
var runtime_1 = require("../runtime");
var AdSurveyTransparencyContent_1 = require("./AdSurveyTransparencyContent");
/**
 * Check if a given object implements the AdSurvey interface.
 */
function instanceOfAdSurvey(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdSurvey = instanceOfAdSurvey;
function AdSurveyFromJSON(json) {
    return AdSurveyFromJSONTyped(json, false);
}
exports.AdSurveyFromJSON = AdSurveyFromJSON;
function AdSurveyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'brandName': !(0, runtime_1.exists)(json, 'brand_name') ? undefined : json['brand_name'],
        'languageCode': !(0, runtime_1.exists)(json, 'language_code') ? undefined : json['language_code'],
        'transparencyContent': !(0, runtime_1.exists)(json, 'transparency_content') ? undefined : (0, AdSurveyTransparencyContent_1.AdSurveyTransparencyContentFromJSON)(json['transparency_content']),
    };
}
exports.AdSurveyFromJSONTyped = AdSurveyFromJSONTyped;
function AdSurveyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'brand_name': value.brandName,
        'language_code': value.languageCode,
        'transparency_content': (0, AdSurveyTransparencyContent_1.AdSurveyTransparencyContentToJSON)(value.transparencyContent),
    };
}
exports.AdSurveyToJSON = AdSurveyToJSON;
